import { createHashHistory, History } from 'history';

export const HISTORY: History = createHashHistory({
    basename: '/',
    hashType: 'hashbang',
});
